__turbopack_context__.v({
  "autoMatch": "Explore-module-scss-module__YYfIeq__autoMatch",
  "autoMatchContainer": "Explore-module-scss-module__YYfIeq__autoMatchContainer",
  "bannerWrapperBoxShadowOrange": "Explore-module-scss-module__YYfIeq__bannerWrapperBoxShadowOrange",
  "innerNav": "Explore-module-scss-module__YYfIeq__innerNav",
  "mph": "Explore-module-scss-module__YYfIeq__mph",
  "page": "Explore-module-scss-module__YYfIeq__page",
  "specialStateSubtitle": "Explore-module-scss-module__YYfIeq__specialStateSubtitle",
  "stickyNav": "Explore-module-scss-module__YYfIeq__stickyNav",
  "topTitleWrapper": "Explore-module-scss-module__YYfIeq__topTitleWrapper",
});
